import type { ApiClient } from '@klareospace/pharos-lib-front-utils';
import { reviveTenantBillingConfigurationView, unwrapApiData } from '@klareospace/pharos-lib-front-utils';
import type { PharosApiResponse, TenantBillingConfigurationView } from '@klareospace/pharos-lib-types';

// ─── API factory ──────────────────────────────────────────────────────────────

export interface TenantBillingApi {
  getOwnConfiguration: (tenantId: string) => Promise<TenantBillingConfigurationView>;
}

/** Targets the tenant-facing `GET /billing/tenant/:id` route (gated by `billing:read-own`). */
export function createTenantBillingApi(client: ApiClient): TenantBillingApi {
  return {
    getOwnConfiguration: async (tenantId: string): Promise<TenantBillingConfigurationView> => {
      const response = await client.execute<PharosApiResponse<TenantBillingConfigurationView>>(() =>
        client.instance.get(`/billing/tenant/${tenantId}`),
      );
      return reviveTenantBillingConfigurationView(unwrapApiData(response, 'getOwnConfiguration'));
    },
  };
}
